export default "__VITE_ASSET__2e50f6d8__"